import React, { Fragment, useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import {
    Card,
    CardBody,
    CardHeader,
    FormText,
    Row, Col,
    Button
} from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import './index.css';
import cratioLogo from "../../assets/utils/images/logo-green.png"
import { getServerDomainURL, getSessionValue, getWhatsAppSettings, updateWhatsAppCredentials } from '../../Common/Appcommon';
import whatsappApi from "../../services/whatsappApi.service";
import Common from "../../Common/Common";

export default function Onboarding(props) {
    const form = useForm();
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, getValues } = form;
    let baseUrl = getServerDomainURL();
    let webhookUrl = baseUrl + "/Customize/whatsapp/webhook.php";
    const [isCopied, setCopyStatus] = useState(false);
    const [formData, setFormData] = useState({});
    useEffect(() => {
        document.title = 'Welcome to Cratio Whatsapp';
    }, []);

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(formData => ({
            ...formData,
            [name]: value
        }));
    }

    const webhookUrlCopy = () => {
        setCopyStatus(true);
    }

    const onWhatsappApiSubmit = async () => {
        let {account_id, access_token, phone_number} = formData;
        let res = await whatsappApi.getLinkedPhoneNumbers(account_id, access_token, true);
        if (res.status === 'success') {
            let phoneNumbersInfo = res.data;
            let defaultPhoneId = phone_number;
            let defaultNumber = "";
            phoneNumbersInfo.map((phoneInfo) => {
                if(phoneInfo.id === defaultPhoneId){
                    defaultNumber = phoneInfo.display_phone_number;
                }
            });
            let userId = getSessionValue('loginuserid');
            let wpStatus = await updateWhatsAppCredentials(account_id, access_token, defaultNumber, defaultPhoneId, userId);
            if(wpStatus){
                await getWhatsAppSettings(true);
                window.location.href = '/#/inbox';
            }
        }
    }

    return (
<Common pageTitle={"Onboarding"} showLoader={false} mainContent={
<Fragment>
        <div className='wp-onboarding-container'>
            <div className='container-xxl'>
                <div className='onboarding-wrapper d-flex-alone justify-content-center'>
                    <div className='onboarding-steps-inner mb-5 w-100'>
                        <br /><br />
                        <Card className={'mb-4'}>
                            <CardBody>
                                
                                <div class="mb-3 mx-n3 mx-md-n4"></div>
                                <div class="text-center">
                                    <h2 class="mb-2">Setup your WhatsApp Cloud API credentials</h2>
                                    <p class="mb-4">Generate your API credentials by watching the video below and add them in the form below.</p>
                                </div>
                                <div>
                                    <div class="ratio ratio-16x9 mb-4">
                                        <iframe allowfullscreen="" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.youtube.com/embed/b9c4JI6S4H4?si=Mz1tB-4WGgJoomFf?autoplay=1&amp;fs=1&amp;iv_load_policy=3&amp;showinfo=0&amp;rel=0&amp;cc_load_policy=0"></iframe>
                                    </div>
                                </div>
                                <p class="mb-4">
                                    <b>Callback URL</b>: <code><CopyToClipboard onCopy={(e) => { webhookUrlCopy() }} text={webhookUrl}>
                                        <a className='cursor-pointer'>{webhookUrl}</a>
                                    </CopyToClipboard></code> {isCopied ? (
                                        <FormText color="success">copied.</FormText>
                                    ) : null}<br />
                                    <b>Verify Token</b>: <code>Cr@tio#3241</code>
                                </p>
                                <hr class="my-4"></hr>
                                <div className='form-container'>
                                    <p>Watch the video above to get the following WhatsApp Cloud API credentials.</p>
                                    <form name={'onboard-form'} onSubmit={handleActionFormSubmit(onWhatsappApiSubmit)}>
                                        <div className='mt-3 '>
                                            <Row className=''>
                                                <Col md="6">
                                                    <div>
                                                        <div className={`mb-3`}>
                                                            <label className="automation-lbl form-label"> PHONE NUMBER ID </label>
                                                            <Controller
                                                                name="phone_number"
                                                                control={control}
                                                                rules={{ required: getValues("phone_number") === undefined ? "Please provide Name" : "" }}
                                                                render={({ field }) => {
                                                                    return (
                                                                        <input
                                                                            {...field}
                                                                            value={formData['phone_number'] !== undefined ? formData['phone_number'] : ''}
                                                                            onChange={
                                                                                (e) => {
                                                                                    handleChange(e)
                                                                                    field.onChange(e)
                                                                                }
                                                                            }
                                                                            name={'phone_number'}
                                                                            type={'text'}
                                                                            className={`form-control ${errors.phone_number ? 'is-invalid' : ''}`}
                                                                            autoComplete={'off'}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                            {errors.phone_number && <em className={`error invalid-feedback`}>{errors.phone_number.message}</em>}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <div>
                                                        <div className={`mb-3`}>
                                                            <label className="automation-lbl form-label"> WHATSAPP BUSINESS ACCOUNT ID </label>
                                                            <Controller
                                                                name="account_id"
                                                                control={control}
                                                                rules={{ required: getValues("account_id") === undefined ? "Please provide Account ID" : "" }}
                                                                render={({ field }) => {
                                                                    return (
                                                                        <input
                                                                            {...field}
                                                                            value={formData['account_id'] !== undefined ? formData['account_id'] : ''}
                                                                            onChange={
                                                                                (e) => {
                                                                                    handleChange(e)
                                                                                    field.onChange(e)
                                                                                }
                                                                            }
                                                                            name={'account_id'}
                                                                            type={'text'}
                                                                            className={`form-control ${errors.account_id ? 'is-invalid' : ''}`}
                                                                            autoComplete={'off'}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                            {errors.account_id && <em className={`error invalid-feedback`}>{errors.account_id.message}</em>}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className=''>
                                                <Col md="12">
                                                    <div>
                                                        <div className={`mb-3`}>
                                                            <label className="automation-lbl form-label"> PERMANENT ACCESS TOKEN </label>
                                                            <Controller
                                                                name="access_token"
                                                                control={control}
                                                                rules={{ required: getValues("access_token") === undefined ? "Please provide Access Token" : "" }}
                                                                render={({ field }) => {
                                                                    return (
                                                                        <textarea
                                                                            {...field}
                                                                            value={formData['access_token'] !== undefined ? formData['access_token'] : ''}
                                                                            onChange={
                                                                                (e) => {
                                                                                    handleChange(e)
                                                                                    field.onChange(e)
                                                                                }
                                                                            }
                                                                            name={'access_token'}
                                                                            className={`form-control ${errors.access_token ? 'is-invalid' : ''}`}
                                                                            autoComplete={'off'}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                            {errors.access_token && <em className={`error invalid-feedback`}>{errors.access_token.message}</em>}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className='btn-container d-flex justify-content-center'>
                                            <button className='btn btn-success btn-lg'>Validate and Proceed</button>
                                        </div>
                                    </form>
                                </div>

                            </CardBody>
                        </Card>

                        <Card className={""}>
                            
                        </Card>
                        <br /><br />
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
  } />
    )
}